// Pleassy theme.js — ES module, no dependencies.
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const desktop = matchMedia('(min-width: 990px)');

/* Dialogs: [data-open="id"] opens, [data-close] or backdrop closes. showModal traps focus and handles Escape. */
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.open);
    if (dialog && !dialog.open) {
      e.preventDefault();
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      dialog.addEventListener('close', () => {
        opener.setAttribute('aria-expanded', 'false');
        opener.focus();
      }, { once: true });
    }
    return;
  }
  if (e.target.closest('[data-close]')) e.target.closest('dialog')?.close();
  else if (e.target.tagName === 'DIALOG') e.target.close();
});

/* Quantity steppers */
document.addEventListener('click', (e) => {
  const step = e.target.closest('[data-quantity] [data-step]');
  if (!step) return;
  const input = $('input', step.parentElement);
  const min = Number(input.min || 0);
  input.value = Math.max(min, (Number(input.value) || 0) + Number(step.dataset.step));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Localization selects submit on change */
document.addEventListener('change', (e) => {
  if (e.target.matches('[data-localization-select]')) e.target.form.submit();
});

/* Sticky header: hides on scroll down, returns on scroll up */
const headerSection = $('[data-header]')?.closest('.shopify-section');
if (headerSection) {
  headerSection.classList.add('section-header--sticky');
  let last = scrollY;
  addEventListener('scroll', () => {
    const y = scrollY;
    const hide = y > last && y > headerSection.offsetHeight * 2 && !$('[data-mega] [aria-expanded="true"]');
    headerSection.classList.toggle('is-hidden', hide);
    last = y;
  }, { passive: true });
}

/* Megamenu: hover with 150 ms delay, click and keyboard */
const megaItems = $$('[data-mega]');
const setMega = (item, open) => {
  $('button', item).setAttribute('aria-expanded', String(open));
  $('[data-mega-panel]', item).hidden = !open;
};
megaItems.forEach((item) => {
  const button = $('button', item);
  let timer;
  item.addEventListener('mouseenter', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      megaItems.forEach((other) => other !== item && setMega(other, false));
      setMega(item, true);
    }, 150);
  });
  item.addEventListener('mouseleave', () => {
    clearTimeout(timer);
    timer = setTimeout(() => setMega(item, false), 150);
  });
  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') !== 'true';
    megaItems.forEach((other) => setMega(other, false));
    setMega(item, open);
  });
  item.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { setMega(item, false); button.focus(); }
  });
  item.addEventListener('focusout', (e) => {
    if (!item.contains(e.relatedTarget)) setMega(item, false);
  });
});

/* Footer columns: accordions on mobile, always open on desktop */
const syncFooter = () => $$('[data-footer-col]').forEach((d) => { if (desktop.matches) d.open = true; });
syncFooter();
desktop.addEventListener('change', syncFooter);
document.addEventListener('click', (e) => {
  if (desktop.matches && e.target.closest('[data-footer-col] > summary')) e.preventDefault();
});

/* Campaign countdown to a fixed end date; the bar removes itself afterwards. No resets. */
$$('[data-countdown]').forEach((el) => {
  const end = Date.parse(el.dataset.countdown);
  const bar = el.closest('[data-campaign]');
  const tick = () => {
    const left = end - Date.now();
    if (!(left > 0)) { bar?.remove(); return false; }
    const d = Math.floor(left / 864e5);
    const h = String(Math.floor(left / 36e5) % 24).padStart(2, '0');
    const m = String(Math.floor(left / 6e4) % 60).padStart(2, '0');
    el.textContent = `${d}d ${h}h ${m}m`;
    return true;
  };
  if (tick()) setInterval(tick, 30000);
});

/* Offer timer: live countdown to the end of the current cycle (local time), then starts again. Cycle in hours from data-timer-cycle. */
const cycleTimers = $$('[data-timer-cycle]');
if (cycleTimers.length) {
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const now = new Date();
    cycleTimers.forEach((el) => {
      const hours = Number(el.dataset.timerCycle) || 24;
      const dayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      const elapsed = now.getTime() - dayStart;
      const cycle = hours * 36e5;
      const left = cycle - (elapsed % cycle);
      const h = Math.floor(left / 36e5);
      const m = Math.floor(left / 6e4) % 60;
      const s = Math.floor(left / 1e3) % 60;
      el.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
    });
  };
  tick();
  setInterval(tick, 1000);
}

/* Cookie preferences link opens Shopify's privacy banner preferences when available */
document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-privacy-preferences]');
  if (link && window.privacyBanner?.showPreferences) {
    e.preventDefault();
    window.privacyBanner.showPreferences();
  }
});

/* Card swatches swap the card photo */
document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.card [data-swatch-src]');
  if (!swatch) return;
  e.preventDefault();
  const img = swatch.closest('.card').querySelector('.card__img');
  if (img) { img.srcset = ''; img.src = swatch.dataset.swatchSrc; }
});

/* Shared cart helpers: one add to cart path for PDP, sticky bar, quick add and upsell.
   Bundled section rendering returns the header (count) and, from phase 4, the cart drawer in the same response. */
const Pleassy = (window.Pleassy = window.Pleassy || {});
Pleassy.sectionIdOf = (selector) => document.querySelector(selector)?.closest('.shopify-section')?.id.replace('shopify-section-', '');
Pleassy.cartSectionIds = () => [Pleassy.sectionIdOf('[data-header]'), Pleassy.sectionIdOf('[data-cart-drawer]'), Pleassy.sectionIdOf('[data-main-cart]')].filter(Boolean);
Pleassy.renderCartSections = (sections = {}) => {
  Object.values(sections).forEach((html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('[data-cart-sync]').forEach((fresh) => {
      document.querySelectorAll(`[data-cart-sync="${fresh.dataset.cartSync}"]`).forEach((old) => old.replaceWith(fresh.cloneNode(true)));
    });
  });
};
Pleassy.addToCart = async (formData) => {
  formData.append('sections', Pleassy.cartSectionIds().join(','));
  formData.append('sections_url', location.pathname);
  const res = await fetch(`${window.routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
  const data = await res.json();
  if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');
  Pleassy.renderCartSections(data.sections);
  document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
  return data;
};
Pleassy.buttonState = (button, state) => {
  if (!button) return;
  button.removeAttribute('aria-busy');
  delete button.dataset.state;
  if (state === 'busy') button.setAttribute('aria-busy', 'true');
  if (state === 'added') {
    button.dataset.state = 'added';
    setTimeout(() => { delete button.dataset.state; }, 1500);
  }
};

/* Lazy sections: product recommendations load when they come near the viewport */
const swapSection = (el, html, selector) => {
  const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  if (fresh) el.replaceWith(fresh);
};
document.querySelectorAll('[data-recommendations]').forEach((el) => {
  new IntersectionObserver(async ([entry], io) => {
    if (!entry.isIntersecting) return;
    io.disconnect();
    const res = await fetch(el.dataset.url);
    swapSection(el, await res.text(), '[data-recommendations]');
  }, { rootMargin: '400px' }).observe(el);
});

/* Small add forms (frequently bought together, cart upsell, quick add) */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-quick-add-form]');
  if (!form) return;
  e.preventDefault();
  const button = form.querySelector('[data-add-to-cart]');
  Pleassy.buttonState(button, 'busy');
  try {
    await Pleassy.addToCart(new FormData(form));
    Pleassy.buttonState(button, 'added');
    const host = form.closest('#QuickAdd');
    if (host) host.close();
  } catch (err) {
    Pleassy.buttonState(button, null);
    alert(err.message);
  }
});

/* Quick add on cards with variants: load the compact choice layer into the QuickAdd drawer */
document.addEventListener('click', async (e) => {
  const trigger = e.target.closest('[data-quick-add-url]');
  if (!trigger) return;
  e.preventDefault();
  const dialog = document.getElementById('QuickAdd');
  const body = dialog.querySelector('[data-quick-add-body]');
  body.innerHTML = '';
  Pleassy.buttonState(trigger, 'busy');
  const html = await (await fetch(trigger.dataset.quickAddUrl)).text();
  Pleassy.buttonState(trigger, null);
  const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-quick-add-content]');
  if (!content) { location.href = trigger.dataset.quickAddUrl.split('?')[0]; return; }
  body.append(content);
  dialog.showModal();
  dialog.addEventListener('close', () => trigger.focus(), { once: true });
});

/* Recently viewed: remember product ids (localStorage, functional only) and render them through search */
const RECENT_KEY = 'pleassy:recent';
const readRecent = () => { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch { return []; } };
const productJson = document.querySelector('[data-product-json]');
if (productJson) {
  const id = JSON.parse(productJson.textContent).id;
  try { localStorage.setItem(RECENT_KEY, JSON.stringify([id, ...readRecent().filter((x) => x !== id)].slice(0, 9))); } catch {}
}
document.querySelectorAll('[data-recently-viewed]').forEach(async (el) => {
  const current = Number(el.dataset.current);
  const ids = readRecent().filter((x) => x !== current).slice(0, 8);
  if (!ids.length) return;
  const q = ids.map((x) => `id:${x}`).join(' OR ');
  const res = await fetch(`${window.routes.search_url}?q=${encodeURIComponent(q)}&type=product&section_id=${el.dataset.sectionId}`);
  const fresh = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('[data-recently-viewed]');
  if (!fresh) return;
  fresh.querySelectorAll('[data-product-id]').forEach((li, i) => {
    if (Number(li.dataset.productId) === current || i > 4) li.remove();
  });
  [...fresh.querySelectorAll('[data-product-id]')].slice(4).forEach((li) => li.remove());
  el.replaceWith(fresh);
});

/* Product rails: arrows scroll one card width */
document.addEventListener('click', (e) => {
  const arrow = e.target.closest('[data-rail-prev], [data-rail-next]');
  if (!arrow) return;
  const rail = arrow.closest('[data-rail-host]')?.querySelector('[data-rail]');
  if (!rail) return;
  const step = rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth;
  rail.scrollBy({ left: arrow.hasAttribute('data-rail-next') ? step : -step, behavior: 'smooth' });
});
